export default __webpack_public_path__ + "static/media/phone-receiver-signup.632da2d9.svg";